export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE'
export const FETCH_DATA_REQUEST_PENDING = 'FETCH_DATA_PENDING'
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
export const GET_BATCH_SUCCESSFUL = 'GET_BATCH_SUCCESSFUL'
export const COPY_BATCH_SUCCESSFUL = 'COPY_BATCH_SUCCESSFUL'
export const DELETE_BATCH_CONFIRM = 'DELETE_BATCH_CONFIRM'
